














































import {Component, Prop, Vue} from 'vue-property-decorator';
import { Store } from 'vuex';
import {api} from '@/api';
import {ISelectChoices} from '@/interfaces';
import Multiselect from 'vue-multiselect';

@Component({
  components: {
    Multiselect,
  },
})
export default class CustomSelectInput extends Vue {
  @Prop({default: ''}) public name!: string;
  @Prop({default: ''}) public id!: string;
  @Prop({default: ''}) public choicesUrl!: string;
  @Prop({default: null}) public defaultValue!: string;
  @Prop({default: () => undefined}) public handleChange!: any;
  @Prop({default: false}) public multiple!: boolean;
  @Prop({default: false}) public clearable!: boolean;
  @Prop({default: null}) public emptyOptionLabel!: string | null;

  public options: ISelectChoices = {
        choices: ['', ''],
  };

  public async loadOptions() {
    const response = await api.getSelectChoices(this.choicesUrl, this.$store.getters.token);
    if (response.data) {
      this.options = response.data;
    }
  }

  public async created() {
    await this.loadOptions();
  }

  get multipleOptions() {
    const newList: any = [];
    for (const [key, value] of Object.entries(this.options.choices)) {
      if (value[0]) {
        newList.push({
          id: value[0],
          name: value[1],
        });
      }
    }
    return newList;
  }

  get multipleDefaultValue() {
    const newList: any = [];
    for (const [key, value] of Object.entries(this.options.choices)) {
      if (this.defaultValue.includes(value[0])) {
        newList.push({
          id: value[0],
          name: value[1],
        });
      }
    }
    return newList;
  }
}
